import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    standalone: true,
    imports: [CommonModule, SafeHtmlPipe]
})
export class DisclaimerComponent implements OnInit{
    @Input() disclaimer;
    @Input() alignment: any = {};

    classes = {};

    constructor() { }

    ngOnInit(): void {
        this.checkAlignment();
    }

    private checkAlignment() {
        /**
         * The reason I have to move alignment assignment into a class is because when it
         * was in the template the order was getting weird.
         *
         * I'm reusing the alignment classes from the header component and it requires
         * a ' ' before the class name. So if 'desktop' or 'mobile' are at the beginning of the
         * class property it doesn't work. This was happening and there was no way to control it.
         * It was solved by moving the alignment into a class object and passing it to ngClass.
         */
        // Check for desktop alignment
        if (this.alignment.disclaimerAlignment) {
            this.classes[`desktop-${this.alignment.disclaimerAlignment}`] = true;
        }

        // Check for mobile alignment
        if (this.alignment.mobileDisclaimerAlignment) {
            this.classes[`mobile-${this.alignment.mobileDisclaimerAlignment}`] = true;
        }
    }

}
